export interface SpacerWidgetProps {
  blockId?: string; // lets the editor find this rendered node in the DOM
  height: number | string;
  background?: string;
}

export default function SpacerWidget({ blockId, height, background }: SpacerWidgetProps) {
  return (
    <table role="presentation" width="100%" cellPadding={0} cellSpacing={0} border={0} style={{ background }}>
      <tbody>
        <tr>
          <td data-block-id={blockId} height={height} style={{ fontSize: 0, lineHeight: '0' }}>
            &nbsp;
          </td>
        </tr>
      </tbody>
    </table>
  );
}
